import { setJsonQuery } from 'shared/actions/filterJsonQuery';
import { setSearchQuery } from 'shared/actions/searchQuery';
import { selectSearchQuery } from 'shared/selectors';
import { TReduxStore } from 'shared/types/redux';

export function handleSetJsonQuery(store: TReduxStore, data: { jsonQuery: object }) {
  const searchQuery = selectSearchQuery(store.getState());

  if (searchQuery && searchQuery.trim() !== '') {
    store.dispatch(setSearchQuery(''));
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('search:clearTips'));
    }
  }

  store.dispatch(setJsonQuery(data.jsonQuery));
}
